@if (isActive()) {
  <div class="sx-nav-loader" aria-live="polite" aria-busy="true" role="status">
    <div class="sx-nav-loader__veil"></div>

    <div class="sx-nav-loader__orbs" aria-hidden="true">
      <span class="sx-nav-loader__orb sx-nav-loader__orb--one"></span>
      <span class="sx-nav-loader__orb sx-nav-loader__orb--two"></span>
      <span class="sx-nav-loader__orb sx-nav-loader__orb--three"></span>
    </div>

    <div class="sx-nav-loader__card">
      <span class="sx-nav-loader__spinner"></span>
      <div class="sx-nav-loader__text">
        <strong>Loading</strong>
        <small>Preparing the next screen</small>
      </div>
    </div>
  </div>
}
